<template>
  <v-form>
    <v-container>
      <v-layout>
         <div class="decretosBoton">
          <v-menu bottom>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" small tile outline color="primary">
           <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
          </v-btn>
      </template>
      <v-card class="px-2 py-1">
        <v-card-text class="black--text body-2">
          <v-icon small color="info">info</v-icon>&nbsp;
          <span>Excepto el cargo que declara, el declarante deberá registrar las dos últimas entidades públicas o privadas donde prestó servicios remunerados del tipo de función que desempeño. Únicamente se consignará el mes y el año.</span>
          <br>          
          <span v-show='!(nro < 2)'><v-icon small color="info">info</v-icon>&nbsp;<b>Para el registro de un nuevo cargo, favor eliminar uno existente</b></span>
        </v-card-text>
      </v-card>
    </v-menu>
        </div>
        <v-flex xs12 sm12 md12 v-show='(nro < 2)' class="decretos">
          <alert-extendible texto="Excepto el cargo que declara, el declarante deberá registrar las dos últimas entidades públicas o privadas donde prestó servicios remunerados del tipo de función que desempeño. Únicamente se consignará el mes y el año."></alert-extendible>
        </v-flex> 
        <v-flex xs12 sm12 md12 v-show='!(nro < 2)' class="decretos">
          <v-alert align='justify'
            :value='true'
            color='info'
            icon='info'
            outline
          >Para el registro de un nuevo cargo, favor eliminar uno existente</v-alert>
        </v-flex>             
      </v-layout>
      <v-layout justify-end>
        <v-flex xs12 sm12 md12 v-show='habilitar' class="text-xs-right">
          <v-btn color='success' dark @click.stop='dialog = true; reinicializa()' v-show='nro < 2'>
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
        </v-flex> 
      </v-layout>
      <v-form v-model='valid' ref='form' lazy-validation>
        <v-dialog v-model='dialog' scrollable max-width='850' persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title><h4>Cargo anterior</h4></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-alert
                      :value='true'
                      type='warning'
                      v-show='deleteMode'
                      outline
                    >¿Está seguro de eliminar el cargo siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-text-field
                      v-model='entidad'
                      :rules='dRules'
                      label='Entidad/Empresa Pública*'
                      required
                      maxlength='200'
                      :disabled='this.deleteMode'
                      onkeyup="this.value = this.value.toUpperCase()"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>    
                  <v-flex sm12 md12>
                    <v-text-field
                      v-model='cargo'
                      :rules='dRules'
                      label='Último Cargo que Ocupó en la Entidad*'
                      required
                      maxlength='100'
                      @keyup="cargo = cargo? cargo.replace(/[_/*;:{|}~¦^_+±°`]/g, ''):''"
                      :disabled='this.deleteMode'
                      onkeyup="this.value = this.value.toUpperCase()"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md6>
                    <v-menu
                      :close-on-content-click='false'
                      v-model='menu1'
                      :nudge-right='40'
                      lazy
                      transition='scale-transition'
                      offset-y
                      full-width
                      max-width='290px'
                      min-width='290px'>
                      <template v-slot:activator='{ on }'>
              <v-text-field
                :disabled='deleteMode'
                :value="formatDate(dateFormatted)"
                v-model='dateFormatted'
                @blur="date = parseDate(dateFormatted)"
                label='Desde*'
                hint='Formato MM/AAAA'
                :rules="dateRules"
                v-mask="'##/####'"
                persistent-hint
                prepend-icon='event'
                required
                v-on='on'
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled='deleteMode'
              no-title
              type="month"
              v-model='date'
              @input='menu1 = false'
              locale="es-es"
            ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex sm12 md6>
                    <v-menu
                      v-model='menu2'
                      :close-on-content-click='false'
                      :nudge-right='40'
                      lazy
                      transition='scale-transition'
                      offset-y
                      full-width
                      max-width='290px'
                      min-width='290px'
                    >
             <template v-slot:activator='{ on }'>
              <v-text-field
                :disabled='deleteMode'
                :value="formatDateF(dateFormattedF)"
                v-model='dateFormattedF'
                @blur="dateF = parseDateF(dateFormattedF)"
                label='Hasta*'
                hint='Formato MM/AAAA'
                persistent-hint
                :rules="dateRules"
                v-mask="'##/####'"
                required
                prepend-icon='event'
                v-on='on'
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled='deleteMode'
              no-title
              type="month"
              v-model='dateF'
              @input='menu2 = false'
              locale="es-es"
            ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                     <v-tooltip color="secondary" top>
            <template v-slot:activator='{ on }'>
                    <v-textarea
                      @change="observaciones = $util.sanitiza(observaciones)"
                      v-model='observaciones'
                      label='Observaciones'
                      maxlength='250'
                      :counter='250'
                      v-on='on'
                      hint='Máximo 250 caracteres.'
                      persistent-hint
                      :rules="$validate(['text_area'])"
                      :disabled='deleteMode'
                      rows="1"
                      auto-grow
                    ></v-textarea>
                     </template>
            <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los “Datos de los Cargos Anteriores del Declarante”. 
</span>
          </v-tooltip>
                  </v-flex>
                </v-layout>
                <br>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader><p class='plomo--text'>Por favor llene los campos requeridos*</p></v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn :loading='loadingButton' color='primary' @click='preVerificacion()'>
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div><div v-else><v-icon>save</v-icon>&nbsp;Guardar</div></v-btn>
              <v-btn color='error' @click='cancel()'><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex sm12 md12 v-if='this.nro>0'>
          <v-data-table 
            :headers='headers' 
            :items='datos' 
            class='elevation-1' 
            hide-actions rows-per-page-text='Filas por página'
            :rows-per-page-items="rowsPerPageItems">
            <template slot='no-data'>
              <v-alert
              class="tamanioBoton"
                :value='true'
                color='info'
                icon='info'     
              >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
            </template>
            <template slot='items' slot-scope='props'>
              <td>{{ props.item.nro }}</td>
               <td class='justify-center layout px-0'>
                <v-tooltip  top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class='mx-0' @click='editItem(props.item)' v-on="on">
                      <v-icon color='blue'>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip  top color='red'>
                  <template v-slot:activator="{ on }">
                    <v-btn icon class='mx-0' @click='deleteItem(props.item)' v-on="on">
                      <v-icon color='red'>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.cardec_descripcion_entidad }}</td>
              <td>{{ props.item.cardec_descripcion_cargo }}</td>
              <td>{{ props.item.cardec_fecha_desde.substring(5, 7)}}/{{ props.item.cardec_fecha_desde.substring(0, 4)}}</td>
              <td>{{ props.item.cardec_fecha_hasta.substring(5, 7)}}/{{ props.item.cardec_fecha_hasta.substring(0, 4)}}</td>
              <td><text-extendible :texto='props.item.cardec_observacion'></text-extendible></td>
            </template>
            <template v-slot:pageText="props">
       {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
             </template>
          </v-data-table>
        </v-flex>
        <v-flex sm12 md12 v-else>
            <v-alert
            class="tamanioBoton"
                :value='true'
                color='info'
                icon='info'     
              >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="400">
          <v-card>
            <v-card-title><h4><v-icon color="yellow">warning</v-icon>Advertencia</h4></v-card-title>
            <v-card-text>{{this.mensajeAlerta}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="tamanioBoton" color="primary" flat @click="repetidosModal = false, guardar()"><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn class="tamanioBoton" color="error" flat @click="repetidosModal = false, cancel()"><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import jsonQuery from 'json-query';
export default {
  mixins: [ validate ],
  mounted () {
    this.$root.$on('clickedDatosDeclaracion', () => {
      if (this.$storage.get('ex') === 1) {
        this.codPais = this.$storage.get('codigoPais');
        if (this.codCargoAnterior !== '-1') {
          this.habilitar = true;
        } else {
          this.showMessage('warning', 'Debe registrar primero Cargo Actual');
        }
        this.obtenercargosAnteriores();
      } else {
        this.codPais = this.$storage.get('codigoPais');
      }
    });
  },
  created () {
    if (this.$storage.get('ex') === 1) {
      this.codPais = this.$storage.get('codigoPais');
      if (this.codCargoAnterior !== '-1') {
        this.habilitar = true;
      } else {
        this.showMessage('warning', 'Debe registrar primero Cargo Actual');
      }
      this.obtenercargosAnteriores();
    } else {
      this.codPais = this.$storage.get('codigoPais');
    }
    // Formateo de fecha actual (no es necesario formatear la fecha actual)
    // const [year, month, day] = this.fechaActual.split('-');
    // this.fechaActual = `${day}/${month}/${year}`;
  },
  data: () => ({
    loadingButton: false,
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      { text: 'Entidad', sortable: false, value: 'entidad' },
      { text: 'Cargo', sortable: false, value: 'cargo' },
      { text: 'Desde', sortable: false, value: 'desde' },
      { text: 'Hasta', sortable: false, value: 'hasta' },
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],
    entidad: '',
    cargo: '',
    fechaIni: null,
    fechaFin: null,
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    observaciones: '',
    codCargo: null,
    nro: 0,
    codPais: null,
    dialog: false,
    menu1: false,
    menu2: false,
    editMode: false,
    deleteMode: false,
    codError: null,
    msgError: null,
    statusError: null,
    dRules: [v => !!v || 'Este campo es requerido',
      v => /^[a-zA-Z0-9-_/.*(),.;:=#°ñÑÁáÉéÍíóÓúÚüÜ \r\n]+$/.test(v) || 'Carácter especial no permitido'],
    dateRules: [v => !!v || 'Este campo es requerido',
      v => (v && v.length <= 7) || 'El formato requerido MM/AAAA sólo tiene 7 campos',
      v => (v && /^(0[1-9]|1[012])[- /.](18|19|20|21|22|23)\d\d$/.test(v)) || 'Fecha no válida'],
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: '',
    dateF: new Date().toISOString().substr(0, 10),
    dateFormattedF: '',
    fechaActual: new Date().toISOString().substr(0, 7),
    habilitar: false,
    codCargoAnterior: null,
    valid: false,
    mensaje: null,
    repetidosModal: false,
    mensajeAlerta: '',
    show: ''
  }),
  methods: {
    save () {
      let params = {
        nombre_entidad: this.entidad,
        cargo: this.cargo,
        fecha_ini: this.date + '-01',
        fecha_fin: this.dateF + '-01',
        cod_pais: this.codPais,
        observaciones: this.observaciones
      };
      this.$service
        .post('djbr_registro/cargos_anteriores', params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenercargosAnteriores();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    update () {
      let params = {
        cod_cargo: this.codCargo,
        nombre_entidad: this.entidad,
        cargo: this.cargo,
        fecha_ini: this.date + '-01',
        fecha_fin: this.dateF + '-01',
        cod_pais: this.codPais,
        observaciones: this.observaciones
      };
      this.$service
        .put('djbr_registro/cargos_anteriores', params)
        .then(response => {
          if (response) {
            this.loadingButton = false;
            this.reinicializa();
            this.obtenercargosAnteriores();
            this.editMode = false;
            this.dialog = false;
            this.codError = response.err_codigo;
            this.msgError = response.err_mensaje;
            if (this.codError === 0) {
              this.statusError = 'success';
            } else {
              this.statusError = 'error';
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service
        .delete('djbr_registro/cargos_anteriores/' + this.codCargo)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenercargosAnteriores();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenercargosAnteriores () {
      this.$service
        .get('djbr_registro/cargos_anteriores', {})
        .then(response => {
          this.datos = response;
          for (let i = this.datos.length - 1; i >= 0; i--) {
            if (response[i].cardec_codigo < 1) {
              this.datos.pop();
            }
          }

          this.datos1 = response;
          this.nro = 0;
          for (let i = 0; i < this.datos1.length; i++) {
            if (response[i].cardec_codigo > 0) {
              this.datos1[i].nro = ++this.nro;
            }
          }
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.$refs.form.resetValidation();
    },
    preVerificacion () {
      this.mensajeAlerta = 'Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.';
      if (this.verificarRepetidos() && !this.deleteMode) {
        this.repetidosModal = true;
      } else if (this.verificarFechasRepetidas() && !this.deleteMode) {
        this.repetidosModal = true;
        this.mensajeAlerta = 'Intenta ingresar un rango de fechas repetido. El registro o actualización es responsabilidad del declarante.';
      } else {
        this.guardar();
      }
    },
    guardar () {
      if (this.$refs.form.validate()) {
        this.loadingButton = true;
        if (this.codPais === null && this.$storage.get('ex') === 1 && this.$storage.get('codigoPais') !== null) {
          this.codPais = this.$storage.get('codigoPais');
        }
        let f = this.$storage.get('user').fecha_nacimiento.split('/');
        let fnac = Date.parse(`${f[2]}-${f[1]}`);
        if (Date.parse(this.date) > Date.parse(this.fechaActual)) {
          this.$message['warning']('La fecha desde no es válido, la fecha desde no debe ser mayor a la fecha actual..');
          this.loadingButton = false;
        } else if (Date.parse(this.dateF) > Date.parse(this.fechaActual)) {
          this.$message['warning']('La fecha hasta no es válido, la fecha hasta no debe ser mayor a la fecha actual..');
          this.loadingButton = false;
        } else if (Date.parse(this.date) > Date.parse(this.dateF)) {
          this.$message['warning']('Por Favor revise las fecha hasta, la fecha hasta no puede ser menor a la fecha desde');
          this.loadingButton = false;
        } else if (Date.parse(this.date) < fnac) {
          this.$message['warning']('Por Favor revise la fecha desde, no es valida.');
          this.loadingButton = false;
        } else {
          if (this.editMode) {
            this.update();
          } else {
            if (this.deleteMode) {
              this.delete();
            } else {
              this.save();
            }
          }
        }
      } else {
        this.$message['warning']('Por Favor revise los datos requeridos..');
      }
    },
    reinicializa () {
      this.entidad = '';
      this.cargo = '';
      this.cod_cargo = null;
      this.observaciones = '';
      this.date = '';
      this.dateF = '';
      this.dateFormatted = '';
      this.dateFormattedF = '';
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.entidad = item.cardec_descripcion_entidad;
      this.cargo = item.cardec_descripcion_cargo;
      const [year, month] = item.cardec_fecha_desde.split('-');
      this.date = `${year}-${month}`;
      const [year1, month1] = item.cardec_fecha_hasta.split('-');
      this.dateF = `${year1}-${month1}`;
      this.codCargo = item.cardec_codigo;
      this.observaciones = item.cardec_observacion;
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month] = this.date.split('-');
      return `${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}`;
    },
    formatDateF (dateF) {
      if (!dateF) return null;
      const [year1, month1] = this.dateF.split('-');
      return `${month1}/${year1}`;
    },
    parseDateF (dateF) {
      if (!dateF) return null;
      const [month1, year1] = dateF.split('/');
      return `${year1}-${month1.padStart(2, '0')}`;
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        nombre_entidad: this.entidad.toUpperCase().trim(),
        cargo: this.cargo.toUpperCase().trim(),
        fecha_ini: this.date + '-01',
        fecha_fin: this.dateF + '-01',
        cod_pais: this.codPais,
        observaciones: this.observaciones.toUpperCase().trim() || ''
      };
      let resultQuery = jsonQuery(`lista[*cardec_fecha_desde=${comparing.fecha_ini} &
                                  cardec_fecha_hasta=${comparing.fecha_fin} &
                                  cardec_descripcion_entidad=${comparing.nombre_entidad} & 
                                  cardec_descripcion_cargo=${comparing.cargo} &
                                  pai_codigo=${comparing.cod_pais} &
                                  cardec_observacion=${comparing.observaciones}]`, { data });
      return resultQuery.value.length > 0;
    },
    verificarFechasRepetidas () {
      let data = { lista: this.datos };
      let comparing = {
        nombre_entidad: this.entidad.toUpperCase().trim(),
        cargo: this.cargo.toUpperCase().trim(),
        fecha_ini: this.date + '-01',
        fecha_fin: this.dateF + '-01',
        cod_pais: this.codPais,
        observaciones: this.observaciones.toUpperCase().trim() || ''
      };
      let resultQuery = jsonQuery(`lista[*cardec_fecha_desde=${comparing.fecha_ini} &
                                  cardec_fecha_hasta=${comparing.fecha_fin}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  },
  showMessage (type, men) {
    this.$message[type](`${men}`);
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date);
    },
    computedDateFormattedF () {
      return this.formatDateF(this.dateF);
    }
  },
  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
    },
    dateF (val) {
      this.dateFormattedF = this.formatDateF(this.dateF);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/datosGenerales/cargosAnteriores.vue